import React from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase/FirebaseProvider';
import { UserService, UserRole } from '../../services/userService';
import './UserPage.css';

interface UserPageProps {
  user: any;
  onLogout?: () => void;
}

const UserPage: React.FC<UserPageProps> = ({ user, onLogout }) => {
  const [loading, setLoading] = React.useState(false);
  const [roleChanging, setRoleChanging] = React.useState(false);

  // Check if user is the super admin (your specific UID)
  const isSuperAdmin = user?.id === 'QfgpRkHdTsUWIVsLeyX19SIywSE3';

  const handleRoleChange = async (newRole: UserRole) => {
    if (!user) return;
    
    setRoleChanging(true);
    try {
      // Update the role in Firestore
      await UserService.updateUserRole(user.id, newRole);
      
      // Update local user state
      window.location.reload();
    } catch (error) {
      console.error('Error updating user role:', error);
    } finally {
      setRoleChanging(false);
    }
  };

  const handleLogout = async () => {
    setLoading(true);
    try {
      await signOut(auth);
      if (onLogout) {
        onLogout();
      }
    } catch (error) {
      console.error('Error signing out:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="user-page">
      <div className="user-page-header">
        <h1>User Settings</h1>
      </div>
      
      <div className="user-page-content">
        <div className="user-info-card">
          <h2>Account Information</h2>
          <div className="user-details">
            <div className="user-detail">
              <label>Email:</label>
              <span>{user?.email}</span>
            </div>
          </div>
        </div>

        {isSuperAdmin && (
          <div className="super-actions-card">
            <h2>Super Actions</h2>
            <div className="role-selector">
              <label htmlFor="user-role">User Role:</label>
              <select 
                id="user-role"
                value={user?.role || UserRole.USER}
                onChange={(e) => handleRoleChange(e.target.value as UserRole)}
                disabled={roleChanging}
                className="role-dropdown"
              >
                <option value={UserRole.USER}>User</option>
                <option value={UserRole.ADMIN}>Admin</option>
              </select>
              {roleChanging && <span className="saving-indicator">Saving...</span>}
            </div>
          </div>
        )}

        <div className="user-actions-card">
          <h2>Account Actions</h2>
          <button 
            className="logout-button"
            onClick={handleLogout}
            disabled={loading}
          >
            {loading ? 'Signing out...' : 'Sign Out'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserPage;